import React, { useState } from 'react';
import { useTranslation } from 'services/localization';
import { Routes } from 'routing';
import Container from 'common/components/Container';

import { LoadingData } from 'services/types';

import { CsvUploadData, parseCsv } from './utils';
import { getInventoryFieldsArray, InventoryFields, SkuItem } from 'common/modules/inventory';
import { FixedArticleColumns } from '../ArticlesView/ArticlesTable/columns';
import StartImport from './StartImport';
import VerifyImport from './VerifyImport';
import { Redirect, Route, Switch } from 'react-router-dom';
import history from 'services/history';

interface Props {
	skuItems: SkuItem[];
	inventoryFields: InventoryFields;
	shopId: string;
}

const Import = (props: Props) => {
	const { t } = useTranslation();
	const { shopId } = props;
	const [csvUpload, setCsvUpload] = useState<LoadingData<CsvUploadData | null>>({
		loading: false,
		error: null,
		data: null,
	});

	const handleCsvUpload = async (file: File) => {
		const customInventoryFields = getInventoryFieldsArray(props.inventoryFields);
		const customInventoryFieldIds = customInventoryFields.map((field) => field.id);
		const fixedColumnFields = Object.keys(FixedArticleColumns);
		const existingHeaders = [...fixedColumnFields, ...customInventoryFieldIds];
		setCsvUpload({
			loading: true,
			data: null,
			error: null,
		});
		try {
			const parseResult = await parseCsv(file, t, existingHeaders);
			setCsvUpload({
				loading: false,
				data: parseResult.data,
				error: null,
			});
		} catch (e) {
			setCsvUpload({
				loading: false,
				data: null,
				error: e.message ?? t('common:errors.error'),
			});
		}
		history.push(Routes.INVENTORY_IMPORT_VERIFY);
	};

	return (
		<>
			<Container densePaddingTop>
				<Switch>
					<Route
						exact
						path={Routes.INVENTORY_IMPORT}
						render={() => (
							<StartImport
								loading={csvUpload.loading}
								error={csvUpload.error}
								onCsvUpload={handleCsvUpload}
							/>
						)}
					/>
					<Route
						exact
						path={Routes.INVENTORY_IMPORT_VERIFY}
						render={() => (
							<VerifyImport
								csvUpload={csvUpload.data ?? undefined}
								skuItems={props.skuItems}
								inventoryFields={props.inventoryFields}
								shopId={shopId}
							/>
						)}
					/>
					<Redirect to={Routes.INVENTORY_IMPORT} />
				</Switch>
			</Container>
		</>
	);
};

export default Import;
